import { safeJSONStorage } from '@breezeventures/utils/safe-json-storage';
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import type {
  InitiateConfirmationResponse,
  SigningChallengeResponse,
} from './types';

export const ORDER_CONFIRMATION_SESSION_KEY =
  'merchant_portal_order_confirmation_session';

export type OrderConfirmationStoredSession = {
  orderId: string;
  sessionId: string;
  challenge: SigningChallengeResponse;
  lastRequestTime: number;
};

const SESSION_TTL_MS = 5 * 60 * 1000;

export const orderConfirmationSessionAtom =
  atomWithStorage<OrderConfirmationStoredSession | null>(
    ORDER_CONFIRMATION_SESSION_KEY,
    null,
    safeJSONStorage(),
    { getOnInit: true }
  );

export const setOrderConfirmationSessionAtom = atom(
  null,
  (
    _get,
    set,
    payload: {
      orderId: string;
      data: InitiateConfirmationResponse;
    }
  ) => {
    const { orderId, data } = payload;
    set(orderConfirmationSessionAtom, {
      orderId,
      sessionId: data.sessionId,
      challenge: data.challenge,
      lastRequestTime: Date.now(),
    });
  }
);

export const clearOrderConfirmationSessionAtom = atom(null, (_get, set) => {
  set(orderConfirmationSessionAtom, null);
});

export function getIsOrderConfirmationSessionExpired(
  session: OrderConfirmationStoredSession
): boolean {
  return Date.now() - session.lastRequestTime >= SESSION_TTL_MS;
}

export function getIsOrderConfirmationSessionValid(
  session: OrderConfirmationStoredSession,
  orderId: string
): boolean {
  const isOrderValid = session.orderId === orderId;
  return !getIsOrderConfirmationSessionExpired(session) && isOrderValid;
}
